
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    fill: String,
  },
  computed: {
    pathFill() {
      return this.fill || "rgba(253, 253, 253, 0.4)";
    },
  },
});
